import React, { useEffect, useContext } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import { AuthNavigator } from './AuthNavigator';
import ProtectedRoute from './ProtectedRoute';
import AuthRoutes from './AuthRoutes';
import FamilyRoutes from './FamilyRoutes';
import ChildRoutes from './ChildRoutes';

const AppRoutes = () => {
  const location = useLocation();
  const { user } = useContext(UserContext);

  if (user.loading) {
    return <div>Loading...</div>;
  }

  return (
    <AuthNavigator>
      <Routes>
        <Route path="/auth/*" element={<AuthRoutes />} />
        <Route
          path="/family/*"
          element={
            <ProtectedRoute>
              <FamilyRoutes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/child/*"
          element={
            <ProtectedRoute>
              <ChildRoutes />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/auth/login" replace />} />
      </Routes>
    </AuthNavigator>
  );
};

export default AppRoutes;